import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../components/Card';
import { IconBot, IconCode, IconIntegration, IconChat } from '../components/Icons';
import './Services.css';

function CheckItem({ children }) {
  return (
    <li className="svc-check-item">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <circle cx="8" cy="8" r="8" fill="var(--blue-light)"/>
        <path d="M4.5 8.5l2.2 2.2 4-5" stroke="var(--blue-dark)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
      {children}
    </li>
  );
}

const SERVICES = [
  {
    Icon: IconBot,
    title: 'Discord Products',
    desc: 'Intelligent Discord bots built specifically to improve the developer experience. Each bot is actively maintained and updated based on community feedback.',
    badge: 'Core Focus',
    accent: '#add8ff',
    items: ['Slash command interface', 'Built-in AI capabilities', 'Developer-centric design', 'Regular feature updates'],
  },
  {
    Icon: IconCode,
    title: 'AI Coding Tools',
    desc: 'Code Assist uses a fully custom AI model owned and managed by PERM Systems — built from the ground up for coding assistance on Discord.',
    badge: 'Proprietary AI',
    accent: '#c3f0ca',
    items: ['Custom-trained AI model', 'Code debug, explain, optimise', '20+ languages supported', 'Sub-2s response time'],
  },
  {
    Icon: IconIntegration,
    title: 'Platform Integrations',
    desc: 'Deep integrations that connect Discord with developer workflows — GitHub notifications, documentation lookups, and more.',
    badge: 'Coming Soon',
    accent: '#e8d5ff',
    items: ['GitHub / GitLab integration', 'Docs lookup in-channel', 'Webhook pipelines'],
  },
  {
    Icon: IconChat,
    title: 'Community Suggestions',
    desc: 'Have an idea for a bot or feature that would help developers on Discord? We actively listen and the best ideas become real products.',
    badge: 'Open',
    accent: '#ffd6a5',
    items: ['Submit feature requests', 'Vote on upcoming bots', 'Direct line to the founder'],
  },
];

export default function Services() {
  return (
    <div className="page services-page">
      <section className="services-hero">
        <div className="services-hero__blob" aria-hidden="true" />
        <div className="container animate-fade-up">
          <span className="eyebrow">What We Build</span>
          <h1 className="display-title" style={{ maxWidth: 680 }}>
            Tools built for<br />
            <span style={{ color: 'var(--blue-dark)' }}>developers on Discord.</span>
          </h1>
          <p className="section-body">
            PERM Systems focuses exclusively on improving the developer experience on
            Discord. Every product we build serves that single mission.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="services-grid">
            {SERVICES.map(({ Icon, title, desc, badge, accent, items }, i) => (
              <div key={title} className={`animate-fade-up delay-${i + 1}`}>
                <Card icon={<Icon size={22} />} title={title} desc={desc} badge={badge} accent={accent}>
                  <ul className="services-card__list">
                    {items.map(it => <CheckItem key={it}>{it}</CheckItem>)}
                  </ul>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-sm services-note">
        <div className="container services-note__inner animate-fade-up">
          <div className="services-note__text">
            <h3>We do not build custom bots on request</h3>
            <p>
              PERM Systems does not offer custom bot development for individual servers.
              However, we welcome recommendations for new bots or developer tools that
              could benefit the broader Discord developer community. The best ideas
              become real PERM Systems products.
            </p>
          </div>
          <Link to="/contact" className="btn btn--primary btn--lg" style={{ flexShrink: 0 }}>
            Share an Idea
          </Link>
        </div>
      </section>
    </div>
  );
}